// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"SampleEdit_formGroup__X-BZn","formLabel":"SampleEdit_formLabel__2IXAl","checkboxGroup":"SampleEdit_checkboxGroup__VSNlD","buttons":"SampleEdit_buttons__2i2mP"};